module.exports = {
	cotizadorData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV':'https://www.ford.com.co/cotiza/?modelo=Escape%20H%C3%ADbrida&leadsource=VS',
				'MUSTANG MACH 1':'https://www.ford.com.co/cotiza/?modelo=Mustang%20Mach%201&leadsource=VS',
				'MUSTANG GT PREMIUM':'https://www.ford.com.co/cotiza/?modelo=Mustang&leadsource=VS',
				'ESCAPE ECOBOOST':'https://www.ford.com.co/cotiza/?modelo=Escape%20EcoBoost&leadsource=VS',
				'ESCAPE SE 4X2 FHEV':'https://www.ford.com.co/cotiza/?modelo=Escape%20H%C3%ADbrida&leadsource=VS',
				'ESCAPE SEL 4X2 FHEV':'https://www.ford.com.co/cotiza/?modelo=Escape%20H%C3%ADbrida&leadsource=VS',
				'BRONCO SPORT WILDTRAK':'https://www.ford.com.co/cotiza/?modelo=Bronco%20Sport%204x4&leadsource=VS',
				'BRONCO SPORT BIG BEND':'https://www.ford.com.co/cotiza/?modelo=Bronco%20Sport%204x4&leadsource=VS',
				'BRONCO SPORT OUTER BANKS':'https://www.ford.com.co/cotiza/?modelo=Bronco%20Sport%204x4&leadsource=VS',
				'EDGE SEL':'https://www.ford.com.co/cotiza/?modelo=Edge&leadsource=VS',
				'EDGE ST':'https://www.ford.com.co/cotiza/?modelo=Edge%20ST&leadsource=VS',
				'EXPLORER XLT':'https://www.ford.com.co/cotiza/?modelo=Explorer&leadsource=VS',
				'EXPLORER LIMITED':'https://www.ford.com.co/cotiza/?modelo=Explorer&leadsource=VS',
				'EXPLORER ST':'https://www.ford.com.co/cotiza/?modelo=Explorer%20ST&leadsource=VS',
				'EXPEDITION LIMITED':'https://www.ford.com.co/cotiza/?modelo=Expedition&leadsource=VS',
				'RANGER XL':'https://www.ford.com.co/cotiza/?modelo=Ranger&leadsource=VS',
				'RANGER XLS DIESEL':'https://www.ford.com.co/cotiza/?modelo=Ranger&leadsource=VS',
				'F-150 LARIAT SPORT':'https://www.ford.com.co/cotiza/?modelo=F-150&leadsource=VS',
				'F-150 XLT FHEV':'https://www.ford.com.co/cotiza/?modelo=F-150&leadsource=VS',
				'F-150 PLATINUM FHEV':'https://www.ford.com.co/cotiza/?modelo=F-150&leadsource=VS',
				'RANGER RAPTOR':'https://www.ford.com.co/cotiza/',
				'F-150 RAPTOR':'https://www.ford.com.co/cotiza/?modelo=F-150%20Raptor&leadsource=VS',
				'RANGER FX4': 'https://www.ford.com.co/cotiza/?modelo=Ranger%20FX4&version=FX4&year=2022&cks=JMZ3&leadsource=VS',
				'RANGER LIMITED': 'https://www.ford.com.co/cotiza/?modelo=Ranger%20FX4&version=FX4&year=2022&cks=JMZ3&leadsource=VS',
				'RANGER LIMITED BLACK EDITION': 'https://www.ford.com.co/cotiza/?modelo=Ranger%20FX4&version=FX4&year=2022&cks=JMZ3&leadsource=VS',
				'RANGER XL CHASIS': 'https://www.ford.com.co/cotiza/?modelo=Ranger%20FX4&version=FX4&year=2022&cks=JMZ3&leadsource=VS',
				'RANGER XLT': 'https://www.ford.com.co/cotiza/?modelo=Ranger%20FX4&version=FX4&year=2022&cks=JMZ3&leadsource=VS',
			},
		];
	},
};
